function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint consistent-return: 0 */
import { useState, useLayoutEffect, useRef, useMemo, useEffect, useCallback } from "react";
import { useSpring } from "@react-spring/web";
var RECT_KEYS = ["top", "right", "bottom", "left", "width", "height"];
function isSameRect(a, b) {
  if (!a || !b) return a === b;
  return RECT_KEYS.every(function (key) {
    return a[key] === b[key];
  });
}
var rectMeasures = new Set();
var rectFrame = null;
function runRectMeasures() {
  rectMeasures.forEach(function (measure) {
    return measure();
  });
  rectFrame = requestAnimationFrame(runRectMeasures);
}
function observeRect(measure) {
  rectMeasures.add(measure);
  if (rectFrame === null) {
    rectFrame = requestAnimationFrame(runRectMeasures);
  }
  return function () {
    rectMeasures["delete"](measure);
    if (rectMeasures.size === 0 && rectFrame !== null) {
      cancelAnimationFrame(rectFrame);
      rectFrame = null;
    }
  };
}
export function useRect(nodeRef) {
  var observe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    rect = _useState2[0],
    setRect = _useState2[1];
  var rectRef = useRef(null);
  var measureRect = useCallback(function () {
    if (!nodeRef.current) return;
    var nextRect = nodeRef.current.getBoundingClientRect();
    if (isSameRect(rectRef.current, nextRect)) return;
    rectRef.current = nextRect;
    setRect(nextRect);
  }, [nodeRef]);
  useLayoutEffect(function () {
    if (!observe || !nodeRef.current) return;
    measureRect();
    if (typeof requestAnimationFrame === "undefined") {
      window.addEventListener("scroll", measureRect, true);
      window.addEventListener("resize", measureRect);
      return function () {
        window.removeEventListener("scroll", measureRect, true);
        window.removeEventListener("resize", measureRect);
      };
    }
    return observeRect(measureRect);
  }, [nodeRef, observe, measureRect]);
  return rect;
}
export function useForceUpdate() {
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  return [state, function forceUpdate() {
    setState(function (state) {
      return !state;
    });
  }];
}
export function useIntersectionObserver(options) {
  var ref = useRef();
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    inView = _useState6[0],
    setInView = _useState6[1];
  var observer = useMemo(function () {
    return new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        isIntersecting = _ref2[0].isIntersecting;
      return setInView(isIntersecting);
    }, options);
  }, []);
  useLayoutEffect(function () {
    observer.observe(ref.current);
    return function () {
      return observer.unobserve(ref.current);
    };
  });
  return {
    ref: ref,
    inView: inView
  };
}
var id = 0;
export var useId = function useId() {
  return useState(function () {
    return ++id;
  })[0];
};
export function useEventListener(target, event, listener) {
  var deps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  useLayoutEffect(function () {
    if (!listener || !target) return;
    target.addEventListener(event, listener);
    return function () {
      target.removeEventListener(event, listener);
    };
  }, [target].concat(_toConsumableArray(deps)));
}
export function useAutoId(id) {
  var prefixId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var generatedId = useId();
  return id || "".concat(prefixId, "-").concat(generatedId);
}
export function useOnResize(callback) {
  useEffect(function () {
    window.addEventListener("resize", callback);
    return function () {
      return window.removeEventListener("resize", callback);
    };
  }, [callback]);
}
export function useIsMounted() {
  var isMounted = useRef(false);
  var _useForceUpdate = useForceUpdate(),
    _useForceUpdate2 = _slicedToArray(_useForceUpdate, 2),
    forceUpdate = _useForceUpdate2[1];
  useLayoutEffect(function () {
    isMounted.current = true;
    forceUpdate();
    return function () {
      isMounted.current = false;
    };
  }, []);
  return function () {
    return isMounted.current;
  };
}
export function useMediaQuery(query) {
  var _useState7 = useState(function () {
      return window.matchMedia(query).matches;
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    matches = _useState8[0],
    setMatches = _useState8[1];
  useEffect(function () {
    var mediaQueryList = window.matchMedia(query);
    function onChange(ev) {
      setMatches(ev.matches);
    }
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", onChange);
    } else {
      mediaQueryList.addListener(onChange);
    }
    return function () {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", onChange);
      } else {
        mediaQueryList.removeListener(onChange);
      }
    };
  }, [query]);
  return matches;
}
export function useIsMobile() {
  var MOBILE_BREAKPOINT = 768;
  var isMobile = useMediaQuery("(max-width: ".concat(MOBILE_BREAKPOINT, "px)"));
  return isMobile;
}
export function useStateToRef(state) {
  var ref = useRef(state);
  useEffect(function () {
    ref.current = state;
  }, [state]);
  return ref;
}
export function useAutoHeight(_ref3) {
  var open = _ref3.open,
    springProps = _ref3.springProps;
  var contentRef = useRef(null);
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    height = _useState0[0],
    setHeight = _useState0[1];
  useLayoutEffect(function () {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [open]);
  var style = useSpring(_objectSpread({
    height: open ? height : 0
  }, springProps));
  return {
    style: style,
    contentRef: contentRef
  };
}
//# sourceMappingURL=hooks.js.map